import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { where } from "firebase/firestore";
import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { ConfigurationContext } from '../../../shared/context/ConfigurationContext';
import { DOCUMENT_PRODUCT, DOCUMENT_CATEGORY, LISTENER_CATEGORIES } from '../../../shared/types/firestoreType';

import storageManager from '../../../shared/utility/storageManager';

import './styles.css';

export default function Index(props) {
    const params = useParams();
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT, ['detail']);
    const categoryFirestore = new CommonCloudFirestore(DOCUMENT_CATEGORY);
    const configurationContext = useContext(ConfigurationContext);

    const [id, setId] = useState();
    const [product, setProduct] = useState(undefined);
    const [images, setImages] = useState([]);
    const [features, setFeatures] = useState({});
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState("");

    useEffect(() => {
        setId(params.id);
    }, []);

    useEffect(() => {
        loadInformation();
    }, [id]);

    const loadInformation = async () => {
        setLoading(true);
        if (id !== undefined) {
            var product = await productFirestore.getDocumentById(id);
            const condition = where("visible", "==", true);
            const categories = await storageManager.fetch(LISTENER_CATEGORIES, async () => await categoryFirestore.getDocuments(condition));

            product.document.categories = categories.filter(m => product.document.categories?.includes(m.id));

            setUrl(product.detailCollection.filter(m => m.id === "images")[0]?.data?.filter(m => m.isMain)[0]?.imageLarge);
            setProduct(product.document);
            setImages(product.detailCollection.filter(m => m.id === "images")[0]?.data);
            setFeatures(product.detailCollection.filter(m => m.id === "features")[0] ?? {});
        }
        setLoading(false);
    }

    const scrollDown = (element) => {
        var selector = element.currentTarget.parentElement.children[2].children[0];
        selector.scroll({
            top: 0,
            left: selector.scrollLeft - 200,
            behavior: 'smooth'
        });
    };

    const scrollUp = (element) => {
        var selector = element.currentTarget.parentElement.children[2].children[0];
        selector.scroll({
            top: 0,
            left: selector.scrollLeft + 200,
            behavior: 'smooth'
        });
    };

    const whatsappLink = () => {
        const text = encodeURIComponent(`Hola, me gustaría adquirir el producto:\n${window.location.href}`);
        const url = `https://wa.me/${configurationContext.data.company.whatsapp}?text=${text}`;
        window.open(url, '_blank')
    };

    const onThumbnailImage = (url) => {
        setUrl(url);
    };

    return (
        <div id="components-feature-product-detail">
            <div className="feature-product-detail-name-title">
                Detalle de Producto
            </div>
            <div className='mb-20'>
                <div className='container'>
                    <div className='row justify-content-center pb-2 g-3'>
                        <div className="item-site-content">
                            <div style={{ marginTop: '30px' }} gutter={40} className="components-feature-product-detail-row row">
                                <div className="item-picture col-sm-12 col-md-6 col-lg-6">
                                    <div>
                                        {
                                            product !== undefined ?
                                                <div className="imagen-detail-content">
                                                    <div className="item">
                                                        <div className="vertical-center h-100">
                                                            <img src={url} style={{ padding: '0px 15px' }} />
                                                        </div>
                                                    </div>
                                                </div> : null
                                        }
                                        {
                                            product !== undefined ?
                                                <div className="content-thumbnail-image-content">
                                                    <button size="large" onClick={scrollDown} className="button-left btn btn-light">
                                                        <i className="bi bi-arrow-left"></i>
                                                    </button>
                                                    <button size="large" onClick={scrollUp} className="button-right btn btn-light">
                                                        <i className="bi bi-arrow-right"></i>
                                                    </button>
                                                    <div className="vertical-center">
                                                        <div className="content-thumbnail-image">
                                                            {
                                                                images.map(item => (
                                                                    <div
                                                                        className={"item " + (url === item.url ? "active" : "")}
                                                                        key={item.storageFilename}
                                                                        id={item.storageFilename}
                                                                        onClick={() => onThumbnailImage(item.imageLarge)}
                                                                    >
                                                                        {
                                                                            <div className="vertical-center h-100">
                                                                                <img src={item.imageLarge} alt="picture" />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="item-detail col-sm-12 col-md-6 col-lg-6">
                                    {
                                        product !== undefined ?
                                            <>
                                                <div className="row g-3">
                                                    <div className="col">
                                                        <div className="feature-product-detail-name">
                                                            {product.name}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-auto">
                                                        <button type="button" className="btn-whatsapp" onClick={whatsappLink} target="_blank">
                                                            <i className="bi bi-whatsapp mr-5"></i>
                                                            <span>Solicitar</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                {
                                                    product.oldPrice ?
                                                        <div className="feature-product-detail-old-price">
                                                            S/. {product.oldPrice.toFixed(2)}
                                                        </div> : null
                                                }
                                                <div className="feature-product-detail-price">
                                                    S/. {product.price.toFixed(2)}
                                                </div>
                                                {
                                                    product.freeShipping ?
                                                        <div className="feature-product-detail-free-shipping">
                                                            <div className="vertical-center">
                                                                <i className="bi bi-truck feature-product-detail-free-shipping-icon"></i> &nbsp;&nbsp;
                                                                <span>Incluye envío gratis</span>
                                                            </div>
                                                        </div> : null
                                                }
                                                <div className="feature-product-detail-description fs-15">
                                                    {features.description}
                                                </div>
                                                {
                                                    features.properties?.length === 0 ||
                                                        features.properties?.length === undefined
                                                        ? null : <hr className="hr" style={{ color: '#c1c1c1', margin: '25px 0px' }} />
                                                }
                                                {
                                                    features.properties?.map(item => {
                                                        if (item.type === 1)
                                                            return (
                                                                <div className="additional-information fs-15" key={item.id}>
                                                                    {item.label}:&nbsp;&nbsp;<strong>{item.value}</strong>
                                                                </div>
                                                            );

                                                        if (item.type === 2)
                                                            return (
                                                                <div className="additional-information fs-15" key={item.id}>
                                                                    {item.label}:&nbsp;&nbsp;
                                                                    {
                                                                        item.value.map((item, index) => (
                                                                            <span
                                                                                key={index}
                                                                                className="badge"
                                                                                style={{ color: '#2a6fcf', background: '#fdfdfd', border: '1px solid #73adff', margin: 5 }}
                                                                            >{item}</span>
                                                                        ))
                                                                    }
                                                                </div>
                                                            );
                                                    })
                                                }
                                                {
                                                    product.categories?.length === 0 && product.tags?.length === 0 ? null :
                                                        <hr className="hr" style={{ color: '#c1c1c1', margin: '25px 0px' }} />
                                                }
                                                {
                                                    product.categories?.length > 0 ?
                                                        <div className="additional-information">
                                                            <div className="vertical-center">
                                                                Categorías:&nbsp;&nbsp;
                                                                {
                                                                    product.categories?.map(m => (
                                                                        <span
                                                                            key={m.id}
                                                                            className="badge"
                                                                            style={{ color: '#299160', background: '#edfff7', border: '1px solid #299160', margin: 5 }}
                                                                        >{m.name}</span>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div> : null
                                                }
                                                {
                                                    product.tags?.length > 0 ?
                                                        <div className="additional-information">
                                                            <div className="vertical-center">
                                                                Etiquetas:&nbsp;&nbsp;
                                                                {
                                                                    product.tags?.map(m => (
                                                                        <span
                                                                            key={m}
                                                                            className="badge"
                                                                            style={{ color: '#2a6fcf', background: '#fdfdfd', border: '1px solid #73adff', margin: 5 }}
                                                                        >{m}</span>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div> : null
                                                }

                                            </> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}